module.exports = __webpack_public_path__ + "media/fonts/fa-solid-900-4ec30a0867585d3d5a915cd7d3c958dc.ttf";